import { lazy } from "react"

const DefaultButton = lazy(() => import("./DefaultButton"))
const FilterButton = lazy(() => import("./FilterButton"))
const KeycloakButton = lazy(() => import("./KeycloakButton"))

const useButtons = () => {
  return {
    DefaultButton,
    FilterButton,
    KeycloakButton,
  }
}

export default useButtons;